import { createSelector } from 'reselect';
import TotalPoolBreakdownReportColumns from '../../containers/TotalPoolBreakdownReportColumns';
import TableDefinitions from '../../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.REPORTING_TOTAL_POOL_BREAKDOWN.isLoading;
export const getData = TableDefinitions.REPORTING_TOTAL_POOL_BREAKDOWN.getDataFunction();
export const getColumns = createSelector(getData, TotalPoolBreakdownReportColumns);
